var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.846,
    height: 170.59,
    viewBox: "0 0 129.846 170.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7a63b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3d792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bde1e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.371,
    y1: 0.238,
    x2: 0.793,
    y2: 0.881,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fbd486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f4d48a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3d48b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#efd38d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e3d195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d0cea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac2cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M1416.935,306.611a7.563,7.563,0,0,0-15.121-.032v1.466c-.095,8.4-.11,16.982-.079,25.48.031,7.316.11,13.324.252,18.921.079,3.627.189,6.654.315,9.555.126,2.807.315,6.181.741,9.965a72.9,72.9,0,0,0,4.1,16.225,50.578,50.578,0,0,0,9.208,14.948,46.069,46.069,0,0,0,14.333,10.627,64.711,64.711,0,0,0,16.43,5.282,105.811,105.811,0,0,0,17.549,1.482,81.415,81.415,0,0,0,13.008-1.072,61.157,61.157,0,0,0,12.913-3.721,51.169,51.169,0,0,0,21.066-16.666c5.755-7.695,9.13-16,11.432-22.39,1.214-3.374,2.286-6.78,3.327-10.06,1.277-4.068,2.491-7.931,3.879-11.384l.536-1.246.031-.079a7.324,7.324,0,0,0-3.863-9.744,7.62,7.62,0,0,0-9.965,3.784H1517l-.757,1.782c-1.8,4.541-3.138,8.846-4.446,13.008-.978,3.154-1.908,6.118-3,9.066-2.838,7.931-5.8,13.813-9.335,18.511a36.114,36.114,0,0,1-14.9,11.857,52.02,52.02,0,0,1-19.851,3.579,91.881,91.881,0,0,1-14.806-1.23c-9.839-1.876-17.328-5.645-22.264-11.211a35.74,35.74,0,0,1-6.4-10.47,58.044,58.044,0,0,1-3.185-12.693v-.063c-.3-2.491-.5-5.44-.647-8.735-.126-2.744-.236-5.755-.315-9.224-.126-5.534-.205-11.463-.237-18.637-.031-8.388,0-16.887.079-25.276v-1.577Z",
    transform: "translate(-1401.721 -249.942)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M1488.1,290.313a7.823,7.823,0,0,0-15.641,0v84.8c0,4.778,0,9.492-.205,14.017a50.5,50.5,0,0,1-1.734,12.315l-.458,1.261-.221.631-.284.52-.536,1.056c-.189.331-.441.568-.631.867a8.891,8.891,0,0,1-1.356,1.5c-.189.268-.568.378-.836.583a6.047,6.047,0,0,1-.883.568c-2.617,1.356-6.67,2-11.021,2.034h-.031c-4.241-.047-8.183-.694-10.942-2.113-2.807-1.356-4.557-3.6-5.96-7a42.562,42.562,0,0,1-2.46-12.173c-.379-4.509-.442-9.256-.442-14.1V283.107a7.823,7.823,0,0,0-15.641,0V375.08c0,4.983.063,10.076.5,15.342a56.754,56.754,0,0,0,3.532,16.588c.3.725.552,1.435.914,2.16.394.71.789,1.435,1.183,2.144a29.291,29.291,0,0,0,2.9,4.131,35.688,35.688,0,0,0,3.769,3.626l2.16,1.482a14.044,14.044,0,0,0,2.239,1.309c6.2,3.122,12.5,3.8,18.243,3.879h.047c5.724-.11,12.031-.631,18.464-3.879a22.243,22.243,0,0,0,2.3-1.435,16.9,16.9,0,0,0,2.207-1.624,23.929,23.929,0,0,0,3.721-3.989c.52-.725,1.088-1.451,1.513-2.192.394-.757.788-1.5,1.183-2.255l.568-1.135.41-1.119.8-2.239a63.993,63.993,0,0,0,2.412-16.067c.221-5.061.221-9.934.221-14.727V290.3Z",
    transform: "translate(-1391.859 -263.634)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M1510.387,373.6a7.779,7.779,0,1,0-12.6-9.13v-.063l-1.057,1.34-.725.93a68.876,68.876,0,0,1-4.872,5.6,64.3,64.3,0,0,1-5.519,4.856,55.462,55.462,0,0,1-12.535,7.49,64.625,64.625,0,0,1-14.191,4.21c-1.23.236-2.476.378-3.721.568l-3.343.347-.378.032h0V275.749a7.789,7.789,0,1,0-15.578,0V397.838h0v.173a7.712,7.712,0,0,0,7.789,7.632h.031c11.763.063,24.188-1.782,35.556-6.733a70.676,70.676,0,0,0,15.941-9.524,80.525,80.525,0,0,0,6.953-6.134,83.555,83.555,0,0,0,6.055-6.938l.9-1.151,1.293-1.656",
    transform: "translate(-1382.025 -267.96)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.f8af0861c87f2851a468e3895789d845.svg";
export { ForwardRef as ReactComponent };